import React from "react";

export default function Quote() {
  return (
    <div className="Quote">
      <p className="quote">
        Better wrap up warmly and watch out for that wind!
      </p>
    </div>
  );
}
